module.exports = function(lastTouchEvent, clickTimestamp) {
  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-tap-event-plugin/src/defaultClickRejectionStrategy.js
// module id = 297
// module chunks = 0